import { useState } from 'react';
import Hero from './components/Hero';
import ProcessOverview from './components/ProcessOverview';
import ProductsPreview from './components/ProductsPreview';
import MoringaSection from './components/MoringaSection';
import MoringaTestimonials from './components/MoringaTestimonials';
import ImpactMetrics from './components/ImpactMetrics';
import CallToAction from './components/CallToAction';
import SEO from '../../components/SEO';

export default function Home() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "MY AVA Farms",
    "description": "Leading Black Soldier Fly farming operation in Accra Ghana providing sustainable insect protein, organic fertilizer, BSF training programs, and consultancy services for circular economy agriculture",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/3ca3a64fdbdd1a27f61611d5a6ab11d4/19d8f85f961deb0bcb56f566b071f178.jpeg",
    "image": "https://public.readdy.ai/ai/img_res/088530dafe4dbb7621d3091cb2be77bf.jpg",
    "telephone": "+233233371378",
    "email": "myavagh@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "33 Kwame Nkrumah Ave, Adabraka",
      "addressLocality": "Accra",
      "addressCountry": "GH"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "5.5698",
      "longitude": "-0.1969"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "17:00"
      }
    ],
    "priceRange": "$$",
    "areaServed": {
      "@type": "Country",
      "name": "Ghana"
    },
    "sameAs": [
      "https://wa.me/233233371378"
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "47",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Kwame Asante"
        },
        "datePublished": "2026-02-14",
        "reviewBody": "MY AVA Farms transformed my poultry operation. The BSF larvae are high quality, consistently supplied, and the team gave us excellent training. Waste on our farm has dropped by over 80%. Highly recommended to any farmer in Ghana."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Abena Mensah"
        },
        "datePublished": "2026-01-28",
        "reviewBody": "The moringa powder from MY AVA Farms is genuinely pure — no fillers, no additives. My energy and iron levels improved noticeably after just two weeks. Will keep buying."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Samuel Boateng"
        },
        "datePublished": "2025-12-10",
        "reviewBody": "Attended the 4-week BSF training program and it was worth every cedi. The instructors are knowledgeable, practical, and very supportive after the course. I now run my own small BSF unit."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "author": {
          "@type": "Person",
          "name": "Efua Darko"
        },
        "datePublished": "2025-11-05",
        "reviewBody": "Partnered with MY AVA Farms for organic fertilizer supply. Delivery is reliable, product quality is excellent, and the team is always responsive. Best agricultural partner we have worked with in Accra."
      }
    ]
  };

  return (
    <>
      <SEO
        title="MY AVA Farms | BSF Farming, Training & Protein"
        description="MY AVA Farms is Accra Ghana's leading Black Soldier Fly farming operation providing sustainable insect protein, organic fertilizer, BSF training programs, and consultancy services for circular economy agriculture. Expert BSF larvae cultivation and export services."
        keywords="Black Soldier Fly farming Ghana, BSF training Accra, insect protein Ghana, organic fertilizer Accra, sustainable agriculture Ghana, BSF larvae Ghana, insect farming training, circular economy Ghana"
        ogImage="https://readdy.ai/api/search-image?query=African%20farmers%20working%20with%20black%20soldier%20fly%20larvae%20in%20modern%20sustainable%20farming%20facility%20in%20Ghana&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={schema}
      />
      <div className="min-h-screen bg-white">
        <Hero />
        <ProcessOverview />
        <ProductsPreview />
        <MoringaSection />
        <MoringaTestimonials />
        <ImpactMetrics />
        <CallToAction />
      </div>
    </>
  );
}
